export enum Reporting {
  EVENT = 'event',
  REVENUE = 'revenue',
}

export type ReportingContextState = {
  isRevenue: boolean;
  reportingBy: Reporting;
  updateReportingBy: (reporting: Reporting) => void;
  getReportingTranslation: (key: string) => string;
};
